<div class="filter-title">
    <pf-text bold>{{ filterName }}</pf-text>
    @if (displayValidationMessage) {
        <pf-text type="danger">{{ selectionRequiredMessage }}</pf-text>
    }
</div>
@if (filterKeys) {
    <pf-segmented
        [segmentedOptions]="filterKeys"
        [(ngModel)]="filterKeyIndex"
        (selectedModelChange)="changeFilterKeyHandler($event)"></pf-segmented>
}
@if (filterKeyObject?.searchFacade) {
    <pf-select
        [searchFacade]="filterKeyObject?.searchFacade"
        [control]="searchControl"
        (selected)="selectFiscalPeriod($event)"></pf-select>
} @else {
    <pf-segmented
        [segmentedOptions]="segmentedOptions"
        [(ngModel)]="selectedTimeSegmentIndex"
        (selectedModelChange)="handleSegmentedChange($event)"></pf-segmented>
    @if (customDateRangeActivated) {
        <pf-date-filter
            [lazyProcess]="true"
            [filterOptions]="segmentedOptions"
            (calendarChanged)="calendarChangedHandler($event)"
            (dateRangeChange)="dateRangeChangeHandler($event)"
            (dateRangeClear)="dateRangeClearHandler()"></pf-date-filter>
    }
}
